import React from "react";
import Blob from "./Blob";

const ImageWithBlob = ({
  imageSrc,
  altText = "Image",
  blobSize = "300px",
  imageSize = "120px",
}) => {
  return (
    <div className="relative flex items-center justify-center w-full mb-8">
      {/* Blob (background) */}
      <Blob size={blobSize} />

      {/* Circular background (middle 3D layer) */}
      <div
        className="absolute z-10 rounded-full bg-white/10 backdrop-blur-md shadow-2xl transition-all duration-500"
        style={{
          width: `calc(${imageSize} * 1.2)`,
          height: `calc(${imageSize} * 1.2)`,
        }}
      ></div>

      {/* Image */}
      <img
        src={imageSrc}
        alt={altText}
        className="relative z-20 rounded-full object-cover transition-all duration-500"
        style={{
          width: imageSize,
          height: imageSize,
        }}
      />
    </div>
  );
};

export default ImageWithBlob;
